import { AddMusclesToBone } from "./index30.js";
import { GetAllBones } from "@project-rouge/rg-core";
const AddMusclesToAnatomy = (joint, aggConfig) => {
	const bones = GetAllBones(joint);
	for (const b of bones) AddMusclesToBone(b, aggConfig);
};
export { AddMusclesToAnatomy };

//# sourceMappingURL=index31.js.map